// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"LogoLink_logoLink__XhjzO","solid":"LogoLink_solid__ygonY","logo":"LogoLink_logo__yV32T","zigzagCampaignHero":"LogoLink_zigzagCampaignHero__E3KpU"};